/* RESPONSIBLE TEAM: team-automation-foundations */
import BaseValidator from 'ember-cp-validations/validators/base';
import { inject as service } from '@ember/service';

export default BaseValidator.extend({
  intl: service(),

  validate(value, options) {
    if (!value) {
      return true;
    }

    let blobUrlBlocks = value.filter(
      (block) =>
        block.type === 'audioFile' &&
        typeof block.url === 'string' &&
        block.url.startsWith('blob:'),
    );

    if (blobUrlBlocks.length > 0) {
      return this._extractErrorMessage(options);
    }

    return true;
  },

  _extractErrorMessage(options) {
    let errorMessage = options.message;

    if (options.messageTranslated === true) {
      errorMessage = this.intl.t(options.message);
    }
    return errorMessage;
  },
});
